import i18next from "i18next";
import {
  About,
  BrandLogo,
  BrandName,
  BrandRow,
  CardLogo,
  CardLogosRow,
  CompanyInfoRow,
  CopyRight,
  LegalInformation,
  LinkItem,
  LinksBlock,
  LogosBlock,
  Opportunities,
  PaymentsLogo,
  Socials,
  SocialsLink,
  TkpLogo,
  Wrapper,
} from "./style";

const FooterTopComponent = () => {
  const { t } = i18next;

  return (
    <>
      <BrandRow>
        <BrandLogo src="/images/flyashgabat.jpg" alt="Fly Ashgabat" />
        <BrandName>Fly Ashgabat</BrandName>
      </BrandRow>

      <Wrapper>
        <LinksBlock>
          <LegalInformation>
            <h2>{t("legal_information")}</h2>
            <div>
              <LinkItem to="/rules-of-use-info">{t("rules_of_use")}</LinkItem>
              <LinkItem to="/public-offer-info">{t("offer")}</LinkItem>
              <LinkItem to="/privacy-policy-info">{t("privacy_policy")}</LinkItem>
              <LinkItem to="/payment-info">{t("payment")}</LinkItem>
              <LinkItem to="/refund-request">{t("refund_order")}</LinkItem>
              <LinkItem to="/support">{t("support_footer_link")}</LinkItem>
            </div>
          </LegalInformation>

          <Opportunities>
            <h2>{t("opportunities")}</h2>
            <LinkItem to="/airlines">{t("airlines")}</LinkItem>
            <LinkItem to="/partners">{t("partners")}</LinkItem>
            <LinkItem to="/distribution">{t("distribution")}</LinkItem>
            {/* Страница направлений скрыта из футера; маршрут /flights остаётся рабочим */}
          </Opportunities>

          <About>
            <h2>{t("wannatalk")}</h2>
            <div>
              <LinkItem to="/about">{t("about_company")}</LinkItem>
              <LinkItem to="/contacts">{t("contact_information")}</LinkItem>
            </div>
            <SocialsLink>
              <LinkItem to="https://t.me/flyashgabat.com" target="_blank">
                <Socials src="/socials/telegram-white.svg" alt="Telegram" />
              </LinkItem>
            </SocialsLink>
          </About>
        </LinksBlock>

        <LogosBlock>
          <div>
            <PaymentsLogo src="/images/payment-logos.png" alt="payment-logos" />
          </div>

          <div>
            <TkpLogo src="/images/tkp-logo.png" alt="tkp-logo" />
          </div>
        </LogosBlock>
      </Wrapper>
    </>
  );
};

export default FooterTopComponent;
